import React, { useState, useEffect, lazy } from "react";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { CSS_CLASSES } from "../../css-classes";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { svg_slider_auto_by_300 } from "../../helpers/svg_file";
import Skeleton from "../Skeleton/Skeleton";

// Lazy-load Slider for better performance
const Slider = lazy(() => import("react-slick"));

const initSetting = {
  dots: false,
  arrows: false,
  autoplay: false,
  speed: 50000,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <IoIosArrowForward />,
  prevArrow: <IoIosArrowBack />,
};

const SliderSec = React.memo((props) => {
  const deviceType = localStorage.getItem("device_type") || "mobile";
  const loggedIn = localStorage.getItem("user_token");
  const [sliderSettings, setSliderSettings] = useState(initSetting);
  const [assets, setAssets] = useState([{
    img: svg_slider_auto_by_300[deviceType],
    link: "",
    width: "auto",
    height: 480,
    alt: "slider img",
  }]);

  const [loading, setLoading] = useState(true);

  const { otherMedia, componentSetting } = useSelector((state) => ({
    otherMedia: state.othermediaInformationListR?.data,
    componentSetting: state.componentSettingListR?.data,
  }));

  const setSliderMedia = () => {
    const deviceSlider = otherMedia?.[`${deviceType}_slider`];
    if (deviceSlider?.length) {
      const img = new Image();
      img.onload = () => {
        const callMe = (deviceSlider) => {
          const sliderArr = deviceSlider.map((slider) => ({
            width: slider.width,
            height: slider.height,
            alt: slider.alternate || "slider img",
            img: slider.path,
            link: slider.link,
            description: slider.description
          }));
          setAssets(sliderArr);
          setLoading(false);
        };
        setTimeout(callMe, 1000, deviceSlider);
      };
      img.src = deviceSlider[0].path;
      setLoading(true);

      let date_mili = new Date();
      const diffInMs = localStorage.getItem('start_date_mili') - date_mili.getTime();
      console.log('start_date_mili difference', diffInMs);
    }
  }

  useEffect(() => {
    setSliderMedia();
  }, [otherMedia]);

  useEffect(() => {
    const settings = componentSetting?.slider?.options || {};
    setSliderSettings((prev) => ({
      ...prev,
      ...settings,
      slidesToShow: parseInt(settings.slidesToShow) || 1,
      slidesToScroll: parseInt(settings.slidesToScroll) || 1
    }));
  }, [componentSetting]);
  return (
    <>
      {sliderSettings.slider && (
        <div className="container">
          <div className="banner-outer">
            <div className="banner-inner">
              <Slider {...sliderSettings} className={CSS_CLASSES.sliderMainDiv}>
                {otherMedia?.[`${deviceType}_slider`]?.map((v, i) => (
                  <div key={i}>
                    <Link to={loggedIn && (loggedIn != undefined || loggedIn != null || loggedIn != '') ? v.link : "/register"}>
                      <img
                        src={v.path}
                        width={v.width}
                        height={v.height}
                        alt={v.alt || "no_image"}
                      />
                    </Link>
                  </div>
                ))}
              </Slider >
            </div >
          </div >
        </div >
      )}
    </>
  );
});

SliderSec.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(React.memo(SliderSec));
